import utmFacade from './UtmFacade.js';

let form = {
  data () {
    return {
      leadTarget: 'form-send',
      formName: '',
      modalBind: true,
      msg: '',
      inputs: {
        phone: '',
        email: '',
        name: '',
        comment: '',
        date: '',
      },
      modalWindow: '',
      dataRequest: {}
    }
  },

  methods: {
    sendForm () {
      if (this.inputs.phone && this.inputs.phone.replace(/[\D]/gi, "").length < 6) return

      if (this.inputs.phone || this.inputs.email) {
        let msg = this.msg
        this.msg = `Форма: ${this.formName} <br/>Имя: ${this.inputs.name} <br/>Телефон: ${this.inputs.phone} <br/>E-mail: ${this.inputs.email} <br/>url: ${location.href}`
        if (msg) {
          this.msg += ` <br/>Комментарий: <br/>${msg}`;
        }

        if (this.inputs.date) {
          this.msg += `<br/> Выбранная дата: ${this.inputs.date}`
        }

        if (this.inputs.comment) {
          this.msg += ` <br/>Комментарий клиента: ${this.inputs.comment}`
        } 

        let url = new URLSearchParams(location.search)

       


        let dataRequest = {
          ...this.dataRequest,
          ...this.inputs,
          form: this.formName,
          msg: this.msg,
          url: location.href,
          ...utmFacade.all()
        }

        this.$axios.post('https://rest.onegin.land/api/admin/crm/leads', dataRequest)

        setTimeout(() => {
          location.href = 'https://onegin.land/thanks'
        }, 1500)
        return true
      } else {
        return false
      }
    },
  }
}

export default form
